import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'parseParameters'
})
export class ParseParametersPipe implements PipeTransform {
  transform(message: string, data: { [key: string]: string }): string {
    if (!message || !data) {
      return message || '';
    }

    return message.replace(/\{(\w+)\}/g, (match, variableName) => {
      return data[variableName] || match;
    });
  }
}

